const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/thermostat/sensor_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.thermostat.powerDevice.title',
    secondaryTx: 'categories.thermostat.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.thermostat.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/thermostat/sensor_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.thermostat.confirmPairingMode.title',
    secondaryTx: 'categories.thermostat.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.thermostat.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.thermostat.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/camera/reset_step1.png'),
          primaryTx: 'categories.thermostat.resetDevice.step1.title',
          secondaryTx: 'categories.thermostat.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/camera/reset_step2.png'),
          primaryTx: 'categories.thermostat.resetDevice.step2.title',
          secondaryTx: 'categories.thermostat.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/camera/reset_step3.png'),
          primaryTx: 'categories.thermostat.resetDevice.step3.title',
          secondaryTx: 'categories.thermostat.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
